import { mapActions, mapGetters } from 'vuex';
import moment from 'moment';
import { get } from 'lodash';
import tabs from '@/components/generics/tabs/tabs.vue';
import loaderMixin from '@/mixins/loader';
import { hasMarketHiddenContracts } from '@/utils/helpers';

const MARKET_OPEN_DAYS_TWENTY_HOUR_CHART = 2;
export const TAB_SEVEN_DAYS = '7d';
export const TAB_THIRTY_DAYS = '30d';
export const TAB_NINETY_DAYS = '90d';
export const TAB_TWENTY_FOUR_HOURS = '24h';
export const TAB_RANGE = '0';
export const TAB_STATS = 'stats';

const TAB_LINE = 'line';
const TAB_CANDLE = 'candle';


export default {
  mixins: [
    loaderMixin,
  ],
  components: {
    tabs,
  },
  props: {
    market: {
      type: Object,
      required: true,
    },
    chartOptions: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      activeTabPeriod: null,
      activeTabType: null,
    };
  },
  computed: {
    ...mapGetters('app', ['isLayoutDesktop', 'isLayoutMobile']),
    tabsPeriodStyleModifiers() {
      if (this.isLayoutDesktop) {
        return {
          width: `${this.tabsPeriod.length * 70}px`,
        };
      }
      return {};
    },
    statsOptionAvailable() {
      return this.chartOptions === null;
    },
    useDateRange() {
      return get(this.chartOptions, 'useDateRange', false);
    },
    defaultOffsetValue() {
      return get(this.chartOptions, 'defaultOffsetValue', null);
    },
    showDateRangeTab() {
      return this.useDateRange
        && get(this.chartOptions, 'startDate', null) !== null
        && get(this.chartOptions, 'endDate', null) !== null;
    },
    showDefaultOffsetTab() {
      return !this.useDateRange && this.defaultOffsetValue !== null;
    },
    showAxisAsHours() {
      return get(this.chartOptions, 'showAxisAsHours', false);
    },
    defaultOffsetTab() {
      const titleSuffix = this.showAxisAsHours ? 'hr' : ' Day';
      // const title = `${this.defaultOffsetValue} ${titleSuffix}`;
      const nameSuffix = this.showAxisAsHours ? 'h' : 'd';
      const name = `${this.defaultOffsetValue}${nameSuffix}`;
      return { name, title: null, icon: 'calendar' };
    },
    defaultRangeTab() {
      const suffix = this.showAxisAsHours ? 'h' : 'd';
      return { name: `${TAB_RANGE}${suffix}`, title: null, icon: 'calendar' };
    },
    tabsPeriod() {
      const items = [];

      if (this.statsOptionAvailable && !this.isLayoutDesktop) {
        items.push({ name: TAB_STATS, title: 'Stats', kind: 'stats' });
      }

      if (this.chartOptions === null || get(this.chartOptions, 'include24hr', false)) {
        items.push({ name: TAB_TWENTY_FOUR_HOURS, title: '24hr' });
      }
      if (this.chartOptions === null || get(this.chartOptions, 'include7day', false)) {
        items.push({ name: TAB_SEVEN_DAYS, title: '7 Day' });
      }
      if (this.chartOptions === null || get(this.chartOptions, 'include30day', false)) {
        items.push({ name: TAB_THIRTY_DAYS, title: '30 Day' });
      }
      if (this.chartOptions === null || get(this.chartOptions, 'include90day', false)) {
        items.push({ name: TAB_NINETY_DAYS, title: '90 Day' });
      }
      if (this.showDateRangeTab) {
        items.push(this.defaultRangeTab);
      } else if (this.showDefaultOffsetTab && !items.find(i => i.name === this.defaultOffsetTab.name)) {
        items.push(this.defaultOffsetTab);
      }
      return items;
    },
    tabsType() {
      const items = [];
      if (this.chartOptions === null || get(this.chartOptions, 'includeCandle', false)) {
        items.push({ name: TAB_CANDLE, title: 'Candle' });
      }
      if (this.chartOptions === null || get(this.chartOptions, 'includeLine', false)) {
        items.push({ name: TAB_LINE, title: 'Line' });
      }
      return items;
    },
  },
  methods: {
    ...mapActions('popup', ['setGenericPopup']),
    ...mapActions('market', ['setChartTimeline', 'getMarketContractsStats', 'setChartType']),
    onTitleClick() {
      this.loaderAdd();
      this.getMarketContractsStats(this.market.marketId)
        .then((data) => {
          this.loaderRemove();
          this.setGenericPopup({
            name: 'market-contracts-stats',
            options: {
              stats: data,
              isFixed: hasMarketHiddenContracts(this.market),
            },
          });
        })
        .catch(() => this.loaderRemove());
    },
    tabChangePeriod(name) {
      this.activeTabPeriod = name;
      this.setChartTimeline(name);
      this.$emit('timelineChange', this.activeTabPeriod);
    },
    tabChangeType(name) {
      this.activeTabType = name;
      this.setChartType(name);
      this.$emit('typeChange', this.activeTabType);
    },
    tabsPeriodHandler(value) {
      const dateOpenedDayDiff = moment().diff(moment(this.market.dateOpened), 'days');
      let activeTabPeriod = (dateOpenedDayDiff < MARKET_OPEN_DAYS_TWENTY_HOUR_CHART) ?
        TAB_TWENTY_FOUR_HOURS :
        TAB_SEVEN_DAYS;

      if (this.showDateRangeTab) {
        activeTabPeriod = this.defaultRangeTab.name;
      } else if (this.showDefaultOffsetTab) {
        activeTabPeriod = this.defaultOffsetTab.name;
      }

      const activeTab = value.find(i => i.name === activeTabPeriod);
      if (activeTab) {
        this.activeTabPeriod = activeTabPeriod;
      } else {
        this.activeTabPeriod = value[0].name;
      }
    },
    tabsTypeHandler(value) {
      if (value.find(i => i.name === TAB_LINE)) {
        this.activeTabType = TAB_LINE;
      } else {
        this.activeTabType = value[0].name;
      }
    },
  },
  watch: {
    tabsPeriod: {
      handler: 'tabsPeriodHandler',
      immediate: true,
    },
    tabsType: {
      handler: 'tabsTypeHandler',
      immediate: true,
    },
  },
};



// WEBPACK FOOTER //
// ./src/components/market/market-detail-charts/timeline/timeline.js